<p>stores-address-modal works!</p>
